{
  "static-content-online-booking-process": {
    "buttons": {},
    "text": {
      "title": "Đặt lịch trực tuyến thật dễ dàng!",
      "description": "Tìm tiệm và chọn dịch vụ, ngày và giờ theo mong muốn của bạn. Xác nhận những thông tin cần thiết và bạn đã hoàn tất!",
      "step-confirm-title": "Hoàn tất",
      "step-confirm-description": "Bạn sẽ nhận được ngay xác nhận và lịch hẹn của bạn đã sẵn sàng",
      "step-find-salon-title": "Tìm tiệm",
      "step-find-salon-description": "Tìm tiệm theo địa điểm, dịch vụ hoặc theo ngày",
      "step-select-date-title": "Chọn ngày và giờ",
      "step-select-date-description": "Bạn có thể chọn bất kỳ ngày và giờ có sẵn",
      "step-select-service-title": "Chọn dịch vụ",
      "step-select-service-description": "Chọn dịch vụ ưa mà bạn mong muốn"
    }
  }
}
